import React from 'react'
import CommonPageContainer from '../Container/CommonPageContainer'
import JobListingFull from '../../Components/JobListingFull/JobListingFull'
import { withRouter } from 'react-router-dom'

function JobListing(props) {
  const { job, inst, campus } = props

  const sendApplication = () => {
    props.history.push('/TeacherOption')
  }

  return (
    <CommonPageContainer>
      <JobListingFull
        isPublic
        job={job}
        inst={inst}
        campus={campus}
        sendApplication={sendApplication}
      />
    </CommonPageContainer>
  )
}

export default withRouter(JobListing)
